import {createSlice} from "@reduxjs/toolkit";

const initialProductState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    productForEdit: undefined,
    lastError: null,
    categories: []
};

export const callTypes = {
    list: "list",
    action: "action"
};

export const productsSlice = createSlice({
    name: "products",
    initialState: initialProductState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        
        // getProductById
        productFetched: (state, action) =>{
            state.actionsLoading = false;
            state.error = null;
            state.productForEdit = action.payload.productForEdit;
        },
        // getAllProducts / GetFilteredProducts
        productsFetched: (state, action) =>{
            state.listLoading = false;
            state.error = null;
            const {totalCount, entities} = action.payload;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        
        //updateProduct
        productUpdated: (state, action) =>{
            state.error = null;
            state.actionsLoading = false;
            // state.entities = state.entities.map(e =>{
            //     if(e.id === action.payload.product.id){
            //         return action.payload.product;
            //     }
            //     return e;
            // })
        },
        
        // fetch from hamrahan
        productsReloaded: (state, action) =>{
            state.error = null;
            state.actionsLoading = false;
        },
        
        productCategoriesLoaded: (state, action) =>{
            state.error = null;
            state.listLoading = false;
            state.categories = action.payload.categories;
        }
    }
})